import { Redo2, Undo2, type LucideIcon } from "lucide-react";
import type { HistoryEventDirection } from "../HistoryDrawer/types";

export const ICONS: Record<HistoryEventDirection, LucideIcon> = {
  undo: Undo2,
  redo: Redo2,
};
